export default {"src":"/_next/static/media/caret-icon.8b0472b4.svg","height":6,"width":10};